export default function StatusBadge({ status }) {
  const key = status?.toLowerCase();

  const styleMap = {
    active: "bg-green-100 text-green-700",
    archived: "bg-gray-200 text-gray-600",

    // suggested future statuses
    upcoming: "bg-blue-100 text-blue-700",
    completed: "bg-emerald-100 text-emerald-700",
    draft: "bg-yellow-100 text-yellow-700",
    cancelled: "bg-red-100 text-red-700",
    full: "bg-orange-100 text-orange-700",
    closed: "bg-gray-300 text-gray-700",
  };

  const styles = styleMap[key] || "bg-gray-200 text-gray-600";

  return (
    <span className={`px-2 py-1 text-xs rounded-full ${styles}`}>
      {status}
    </span>
  );
}
